import type { App } from 'vue'
import GraphVisualization from './components/GraphVisualization.vue'
import GraphToolbar from './components/GraphToolbar.vue'
import GraphEditorToolbar from './components/GraphEditorToolbar.vue'
import { KnowledgeGraph } from './module/g6Graph'
import { VisKnowledgeGraph } from './module/VisNetwork'
import { useGraphEditor } from './composables/useGraphEditor'

// 导出类型
export type { GraphNode, GraphEdge } from './@types'
export type { GraphInitOptions, LayoutType, ToolType } from './module/g6Graph'
export type { RenderEngine } from './components/GraphToolbar.vue'
export type {
  GraphEditor,
  GraphEditorOptions,
  GraphVisualizationRef,
  BatchUpdateRequest,
  GraphNodeInput,
  GraphEdgeInput,
  BatchUpdateResponse
} from './composables/useGraphEditor'

// Vue 插件 install 方法
const install = (app: App) => {
  app.component('GraphVisualization', GraphVisualization)
  app.component('GraphToolbar', GraphToolbar)
  app.component('GraphEditorToolbar', GraphEditorToolbar)
}

// 具名导出（ES Modules）
export { install, GraphVisualization, GraphToolbar, GraphEditorToolbar, KnowledgeGraph, useGraphEditor }
export { VisKnowledgeGraph }

// 自动导出（UMD）- 默认导出
export default {
  install,
  version: '1.0.2'
}
